<!-- faq-entry-title-rotated -->
<template>
	<article class="faq-entry">             
        <div class="faq-entry-title js-faq-entry-title js-faq-entry-title-1 faq-entry-title-angle-down" v-bind:class="{ 'faq-entry-title-rotated': active }" @click="changeView" data-target-id="1">
            <h2 v-bind:style="{ color: activeColor}" >{{title}}</h2>
        </div>                        
	    <div class="faq-entry-content js-faq-entry-content-1" v-bind:class="{ 'faq-entry-content-visible': active }">
	        <p class="MsoNormal">
	        	{{text}}
	        	<ol v-if="id == 0">
				  <li>Pomiar temperatury</li>
				  <li>Alert w przypadku wykrycia osoby o podwyższonej temperaturze ciała,</li>
				  <li>Przedstawienie wyniku pracownikowi upoważnionemu do gromadzenia danych osobowych,</li>
				  <li>Możliwość uzyskania podstawowych informacji statystycznych z wykonanych pomiarów.</li>
				</ol>
			</p>
			<p>Chcesz wiedzieć więcej? <router-link to="/skontaktuj-sie-z-nami">Skontaktuj się z nami</router-link>
			</p>                    
		</div>                
    </article>  
</template>
<script>
export default {
  	name: 'FaqEntry',
  	data: function () {
    	return {
    		active:false,
    		activeColor:'black'
    	}
	},
  	props: {
  		title:String,
  		text:String,
  		id:Number,
  	},
	mounted() {	
		if(this.id == 0){
			this.activeColor = 'red';
		}
	},
	methods: {
	    changeView: function () {
	      this.active=!this.active;
	    }
	}
}
</script>	